// 设备模板信息api
import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'SpecialTasks/List',
        method: 'post',
        data
    })
}

export const detailApi = (data) => {
    return request({
        url: 'SpecialTasks/byData',
        method: 'post',
        data
    })
}

export const saveApi = (data) => {
    return request({
        url: 'SpecialTasks/save',
        method: 'post',
        data
    })
}

export const auditApi = (data) => {
    return request({
        url: 'UserSpecialTasks/toExamine',
        method: 'post',
        data
    })
}

export const setMemberApi = (data) => {
    return request({
        url: 'UserSpecialTasks/save',
        method: 'post',
        data
    })
}